import {BicepsFlexedIcon} from 'lucide-react';
import type {RouteObject} from 'react-router-dom';

import type {MenuItemElement} from '@/components/menu/Menu';
import {protectedLoader} from '@/utils/protectedLoader';

export const routes = [
  {
    path: 'entitlements',
    children: [
      {
        path: '',
        loader: protectedLoader('ROOT', 'FULL_ACCESS'),
        async lazy() {
          const {EntitlementsPage} = await import('./pages/EntitlementsPage');
          return {element: <EntitlementsPage />};
        },
      },
    ],
  },
] as RouteObject[];

export const menuItems = [
  {
    path: '/entitlements',
    text: 'Entitlements',
    icon: <BicepsFlexedIcon />,
    permission: 'FULL_ACCESS',
    entitlement: 'ROOT',
  },
] as MenuItemElement[];
